import { Fragment, useState, useContext } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/20/solid";
import LogicContext from "../Context/LogicContext";
import { useNavigate, useLocation } from "react-router-dom";

interface PropsInterface {
  selectModal: (form: any) => void;
}

export default function ModuleSwitcher({ selectModal }: PropsInterface) {
  const logicContext = useContext(LogicContext);
  const moduleMenuList: any = logicContext.getModule();

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [selected, setSelected] = useState<any>(null);
  const [moduleId, moduleName, userMenu] = pathname.split("/").slice(1, 4);

  const handleSelection = (selection: any) => {
    setSelected(selection);
    selectModal(selection);
    navigate(`/${selection.Module_Id}/${selection.Module_Name.replace(' ','-')}/dashboard`);
  };

  return (
    <div className="relative inline-block w-fit">
      <Listbox value={selected} onChange={handleSelection}>
        <div className="relative">
          <Listbox.Button className="flex items-center justify-between rounded-md bg-blue-600 px-3 py-2 w-[150px] text-white text-sm font-medium hover:bg-blue-700 focus:outline-none">
            <span className="truncate text-white capitalize">
              {selected?.Module_Name || moduleName || "Select Module"}
            </span>
            <ChevronDownIcon className="h-4 w-4 ml-2 flex-shrink-0" />
          </Listbox.Button>

          <Transition
            as={Fragment}
            leave="transition ease-in duration-100 z-999"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute z-10 mt-2 pb-2 w-full overflow-auto rounded-md bg-white shadow-lg ring-1 ring-black/10 focus:outline-none text-xs max-h-60 z-999">
              {Object.keys(moduleMenuList).map((label, i) => {
                const module = moduleMenuList[label][0];
                return (
                  <Listbox.Option
                    key={i}
                    value={module}
                    className={({ active }) =>
                      `relative cursor-pointer select-none py-1 pl-4 pr-4 ${
                        active ? "bg-blue-50 text-blue-700" : "text-gray-800"
                      }`
                    }
                  >
                    {({ selected }) => (
                      <>
                        <span
                          className={`truncate ${
                            selected ? "font-medium" : "font-normal"
                          }`}
                        >
                          {label}
                        </span>
                        {selected ? (
                          <span className="absolute inset-y-0 left-2 flex items-center text-blue-600">
                            <CheckIcon className="h-5 w-5" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                );
              })}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
}
